/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Vehicule
 * 1 = QuaiDechargement
 * 2 = Conteneurs
 * 3 = Dalle
 * 4 = GardeCorps
 * 5 = Camera
 * 6 = Bureau
 * 7 = Autre
 */
export enum RapportIncidentAccidentMateriel {
  Vehicule = 0,
  QuaiDechargement = 1,
  Conteneurs = 2,
  Dalle = 3,
  GardeCorps = 4,
  Camera = 5,
  Bureau = 6,
  Autre = 7
}
